// to avoid default export
export const defaultSlug = '/';

export const inspectRouteSessionSlug = '/inspect-route-session';
